import React, { useState } from "react"
import { Container, Row, Col, ProgressBar, Spinner } from "react-bootstrap"
import "./Loading.css"
import { FaCheckCircle } from "react-icons/fa"
import videos from "../Tutoriales/Videos"
import log from "loglevel"

const Loading = (props) => {
  function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max))
  }

  const [currentVideo, setCurrentVideo] = useState(getRandomInt(videos.length))

  if (props.small) {
    return (
      <Spinner
        animation="border"
        variant="primary"
        style={{ width: "1rem", height: "1rem" }}
      />
    )
  }

  if (props.progress && isNaN(props.progress)) {
    log.info("Progress es un NaN!")
  }

  let size = props.size ? parseInt(props.size) : 3
  return (
    <Container className="loading">
      <Row>
        <Col xs={12} className="text-center">
          {(props.progress === null ||
            props.progress === undefined ||
            props.progress < 100) && (
            <Spinner
              variant="primary"
              animation="border"
              style={{ width: size + "rem", height: size + "rem" }}
            />
          )}
          {props.progress && props.progress >= 100 && (
            <FaCheckCircle
              className="text-primary"
              style={{ width: size + "rem", height: size + "rem" }}
            />
          )}
        </Col>
      </Row>
      {props.message && (
        <Row>
          <Col xs={12} className="text-center">
            {props.message}
          </Col>
        </Row>
      )}
      {props.progress && (
        <Row>
          <Col xs={12}>
            <ProgressBar now={props.progress} label={props.progress + "%"} />
          </Col>
        </Row>
      )}
      {props.videoTutorial && (
        <>
          <Row className="videotutoriales-row">
            <Col xs={0} md={2}></Col>
            <Col xs={12} md={8} className="text-center">
              <h4>Más del Panel Online</h4>
            </Col>
            <Col xs={0} md={2}></Col>
          </Row>
          <Row>
            <Col xs={0} md={2}></Col>
            <Col xs={12} md={8} className="text-center">
              <div className="video-container">
                <video
                  playsInline={true}
                  autoPlay="autoplay"
                  muted
                  id="bgvid"
                  key={currentVideo}
                  onEnded={() => {
                    setCurrentVideo((previous) => {
                      let newVideo = previous + 1
                      if (newVideo >= videos.length) {
                        newVideo = 0
                      }
                      return newVideo
                    })
                    console.log("Video ended! Cambiar video")
                  }}
                >
                  <source src={videos[currentVideo].video} type="video/mp4" />
                </video>
                <div className="video-body">
                  <div className="video-title">
                    {videos[currentVideo].title}
                  </div>
                  <div className="video-description">
                    {videos[currentVideo].description}
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={0} md={2}></Col>
          </Row>
        </>
      )}
    </Container>
  )
}

export default Loading
